import React, { useState, useEffect, useRef } from 'react'
import animationDataBottom from './bottom.json'
import animationDataTop from './top.json'
import lottie from 'lottie-web'
import './MainIllustration.scss'
import Img from 'gatsby-image'
import { StaticQuery, graphql } from "gatsby"

import Popup from './Popup'

export default ({points}) => {

	const [list, setList] = useState(points)
	const animationBottom = useRef(null)
	const animationTop = useRef(null)

	useEffect(() => {
		setList(points)
	}, [points])

	useEffect(() => {
		if(animationBottom !== null) {
			setTimeout(() => {
				lottie.loadAnimation({
					container: animationBottom.current,
					renderer: 'svg',
					loop: true,
					autoplay: true,
					animationData: animationDataBottom
				})
			}, 500)
		}
		if(animationTop !== null) {
			setTimeout(() => {
				lottie.loadAnimation({
					container: animationTop.current,
					renderer: 'svg',
					loop: true,
					autoplay: true,
					animationData: animationDataTop
				})
			}, 500)
		}
	},[])

	const setActive = id => {
		let tempList = list.slice()
		tempList.forEach((item, i) => {
			if (i !== id) { item.active = false }
		})

		tempList[id].active = !tempList[id].active
		setList(tempList)
	}

	const clearList = e => {
		let tempList = list.slice()
		tempList.forEach(item => item.active = false)
		setList(tempList)
	}

	return (
		<StaticQuery
			query={graphql`
				query ImageQuery {
					image: file(relativePath: {eq: "img/test-map-overlay-2-01.png"}) {
						childImageSharp {
							fluid(quality: 100, maxWidth: 2000) {
								...GatsbyImageSharpFluid
							}
						}
					}
				}
			`}
			render={data => (
				<div className="MainIllustration">
					<div className="overlay">
						{
							list.map((item, i) => <Popup key={i} id={i} {...item} setActive={setActive} />)
						}
						<div className="bg" onClick={clearList} onKeyDown={clearList} role="button" aria-label="Lukk åpne vinduer" tabIndex="0" />
					</div>
					<div className="animation-wrapper">
						<div className="animation top" ref={animationTop} />
						<Img fluid={data.image.childImageSharp.fluid} />
						<div className="animation bottom" ref={animationBottom} />
					</div>
					<div className="bg-gradient" />
				</div>
			)}
		/>
	)
}